<template>
    <div class="Nav">
        <div class="Nav__container">
            <div class="Nav__arrow" :class="{ 'disable': current == 1 }" @click="onClick(-1)"><img :src="require('../img/assets/arrow_left.png')" /></div>
            <div class="Nav__pagination">{{ current }}/{{ max }}</div>
            <div class="Nav__arrow" :class="{ 'disable': current == max }" @click="onClick(1)"><img :src="require('../img/assets/arrow_right.png')" /></div>
        </div>
    </div>
</template>
<script>

import { Categories } from '../js/Categories.js'

export default {

    name: 'Nav',
    data: ()=>({
        current: 1,
        max: 0,
    }),
    computed: { 
        categorie() { return this.$store.getters['app/categorie'] },
    },
    watch: {
        'categorie': {
            immediate: true,
            deep: true,
            handler() {    
                this.$nextTick(()=>{
                    this.current = 1
                    const obj = _.find(Categories, { 'id': this.categorie })
                    if(obj) 
                        this.max = Math.ceil(obj.items.length/obj.division)
                })
            }
        },
    },

    mounted() {
    },

    methods: {
        onClick(add) {
            this.$store.commit('app/SET_AMBIANCE', 'click')
            let tmp = this.current
                tmp += add 
            if(tmp == 0) 
                tmp = 1
            if(tmp == this.max + 1) 
                tmp = this.max
            this.current = tmp
            this.$parent.slide = this.current
        },
    },
}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.Nav
    position absolute
    width 100%
    height 50px
    bottom 0

    &__container
        display flex
        flex-direction row
        justify-content space-between
        padding 0 24px

    &__arrow
        width 40px
        height 40px
        cursor pointer

        &.disable 
            pointer-events none 
            opacity .25


</style>































































// WEBPACK FOOTER //
// src/components/defis/components/Nav.vue